module.exports = __webpack_public_path__ + "img/footer0.ec96b32f.png";